module.exports = __webpack_public_path__ + "img/logo-2.13a33706.svg";